export default __webpack_public_path__ + "static/media/logo.b02f0549.svg";